import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';
import BusinessIcon from '@material-ui/icons/Business';
import ViewWeekIcon from '@material-ui/icons/ViewWeek';

import history from '../history';

export const MainListItems = () => {

  const handleRedirection = (route) => {
    console.log("odkowdkowodkw");
    history.push(process.env.REACT_APP_PREFIX_DIR+route);
  };

  return (
    <div>
      <ListItem button onClick={() => handleRedirection("/dashboard")}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Inicio" />
      </ListItem>
      <ListItem button onClick={() => handleRedirection("/companies")}>
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Restaurantes" />
      </ListItem>

      <ListItem button onClick={() => handleRedirection("/structure")}>
        <ListItemIcon>
          <ViewWeekIcon />
        </ListItemIcon>
        <ListItemText primary="Estructura" />
      </ListItem>

      <ListItem button onClick={() => handleRedirection("/settings")}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Configuración" />
      </ListItem>
    </div>
  );
};

export const LogOut = ({logOut}) => {
  return (
    <div>
      <ListItem button onClick={() => logOut()}>
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Cerrar sesión" />
      </ListItem>
    </div>
  );
};
